module.exports = __webpack_public_path__ + "static/media/tech-guy-ipad-code-small.3c647576.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tech-guy-ipad-code-small.jpg
// module id = 183
// module chunks = 0